{
  "checkBackSoonMessage": "Speriamo di avere questa funzionalità attiva e funzionante a breve. Tornate a trovarci presto!",
  "contactUs": "Contattaci",
  "errorBoundaryTitle": "Qualcosa è andato storto",
  "featureInProgressMobileWithWebappUrl": "Stiamo lavorando per trasferire questa funzionalità dalla nostra app Web alle piattaforme mobili. Nel frattempo, puoi utilizzare questa funzionalità su {{webappUrl}}",
  "loadErrorDismissButton": "Congedare",
  "retryButton": "Riprova",
  "loadErrorMessage": "Il nostro team è stato informato e sta lavorando per risolvere il problema.",
  "loadErrorSupportTicketLink": "Crea un ticket di supporto",
  "loadErrorSupportTicketMessage": "Crea un ticket di supporto per monitorare il tuo problema.",
  "loadErrorTitle": "Qualcosa è andato storto",
  "notFoundMessage": "Il contenuto richiesto non esiste.",
  "notFoundTitle": "Non trovato",
  "permissionDeniedHowToGetPermissionHint": "Per accedere a questa funzionalità, contatta un amministratore del tuo account farm.",
  "permissionDeniedMessage": "Non hai l'autorizzazione per eseguire questa azione.",
  "permissionDeniedMissingPermissions": "Autorizzazioni mancanti:",
  "permissionDeniedTitle": "Permesso negato",
  "reloadButton": "Ricaricare",
  "underConstruction": "In costruzione"
}
